export const CExpandedCtaSectionFragment = `
  fragment expandedCtaSection on expandedCtaSection_MatrixField {
    ... on expandedCtaSection_block_Entry {
      heading
      subHeading
      cta {
        type
        url
        text
        target
      }
      copy
    }
  }
`
